<template>
  <nav
    class="navbar navbar-expand-lg navbar-light fixed-top main-navbar main-background-color"
  >
    <button class="navbar-toggler" type="button" @click="changeSideNavTrigger">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="main-navbar-logo" @click="logoClik">
      <img src="../assets/kimaker_logo.png" />
    </div>
    <div
      class="collapse collapse-horizontal navbar-collapse"
      id="navbarSupportedContent"
    >
      <a class="main-navbar-brand">扣件智慧生產系統</a>
      <ul class="navbar-nav me-auto mb-2 mb-lg-0"></ul>
      <form class="d-flex">
        <div
          class="navbar-username"
          style="
            width: auto;
            text-align: right;
            font-size: 16px;
            color: var(--main-font-color);
          "
        >
          <greetingUser></greetingUser>
        </div>
        <div class="main-navbar-button">繁中</div>
        <signOut class="main-navbar-button"></signOut>
      </form>
    </div>
  </nav>
  <div class="d-flex" style="overflow: hidden">
    <div style="">
      <sideNav
        :type="windowInnerWidth > 992 ? 'horizontal' : 'vertical'"
      ></sideNav>
    </div>

    <div class="container-fluid text-center overflow-auto" ref="mainContent">
      <div class="row content">
        <div class="main-content px-0" style="width: 100%; overflow: auto">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
  <div>
    <commonAlert></commonAlert>
    <commonLoadingBar></commonLoadingBar>
  </div>
</template>

<script>
import { computed, onUnmounted, provide, ref, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import greetingUser from "@/components/greetingUser.vue";
import signOut from "@/components/signOut.vue";
import sideNav from "@/components/sideNav.vue";
import commonAlert from "@/components/commonAlert.vue";
import commonLoadingBar from "@/components/commonLoadingBar.vue";
export default {
  components: {
    greetingUser,
    signOut,
    sideNav,
    commonAlert,
    commonLoadingBar,
  },
  setup() {
    const store = useStore();
    const windowInnerWidth = ref(0);

    const path = ref();
    const windowSize = ref("max");
    const sideNavTrigger = ref(true);
    const reurnToHome = ref(false);
    const router = useRouter();
    const mainContent = ref();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideBar = computed(() => store.getters["sideBarTree/get_sideBar"]);
    const sideBarSelect = computed(
      () => store.getters["sideBarTree/get_sideBarSelect"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      change_loginData: (payload) => {
        store.dispatch("getLogin/change_loginData", payload);
      },
      set_sideBarSelect: (payload) => {
        store.dispatch("sideBarTree/set_sideBarSelect", payload);
      },
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      set_options: (payload) => {
        store.dispatch("selectOptions/set_options", payload);
      },
    };

    //function
    //判斷螢幕寬度改變尺寸狀態
    const detectWindowWidth = () => {
      windowInnerWidth.value = window.innerWidth;
      if (windowInnerWidth.value >= 992) {
        windowSize.value = "max";
        sideNavTrigger.value = true;
      } else {
        windowSize.value = "mid";
        sideNavTrigger.value = false;
      }
    };

    //改變側邊導覽列狀態
    const changeSideNavTrigger = () => {
      sideNavTrigger.value = !sideNavTrigger.value;
    };

    //判斷目前所在頁面，改變點擊logo的用途
    const logoClik = () => {
      if (
        windowSize.value == "max" &&
        (path.value == "elecboard" || path.value == "home" || path.value == "heatinstant")
      ) {
        changeSideNavTrigger();
      } else {
        reurnToHome.value = true;
        methods.set_sideBarSelect(["home", "homesite2"]);
        router.push("/index/home");
      }
    };

    const selectOption = () => {
      let params = {};
      params["vuePage"] = "selectoption";
      params["methods"] = "GET";
      params["whichFunction"] = "SelectOption";
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          methods.set_options(result.QueryTableData);
        }
      });
    };
    selectOption();

    const logout = () => {
      var obj = {};
      obj.account = null;
      obj.status = false;
      obj.username = null;
      methods.change_loginData(obj);
      router.push("/");
    };

    watch(sideBarSelect, (newValue, oldValue) => {
      console.log(newValue, oldValue);
      path.value = newValue.page;
    });
    window.addEventListener("resize", detectWindowWidth);
    detectWindowWidth();

    const setSessionItems = () => {};
    window.addEventListener("beforeunload", setSessionItems);

    window.addEventListener("scroll", function () {
      if (window.scrollY > 0) {
        sideNavTrigger.value = false;
      }
    });

    provide("mainContent", mainContent);
    provide("sideNavTrigger", sideNavTrigger);
    provide("reurnToHome", reurnToHome);
    provide("path", path);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
      window.removeEventListener("resize", detectWindowWidth);
    });

    return {
      mainContent,
      loginData,
      sideBar,
      sideBarSelect,
      ...methods,
      sideNavTrigger,
      path,
      windowInnerWidth,
      changeSideNavTrigger,
      logoClik,
      logout,
    };
  },
};
</script>

<style>
:root {
  --main-bg-color: #4b8c80;
  --main-font-color: #ffffff;
  --main-status-danger-color: #ff0000;
  --main-status-success-color: #00b152;
  --main-status-short-color: #99f98c;
  --main-status-maintain-color: #cccdfe;
  --main-status-shunting-color: #09b0ff;
  --main-status-warning-color: #ffc100;
  --main-status-secondary-color: #6c757d;
  --main-status-stop-color: #cccccc;
  --main-status-nodata-color: #f2f2f2;
}
.main-navbar {
  position: relative;
  padding: 4px 60px 4px 16px;
  min-height: 60px;
}
.main-background-color {
  background-color: #c8c9ca;
}
.main-navbar-logo img {
  height: 35px;
  width: 240px;
  margin-right: 16px;
  padding: 0px;
  cursor: pointer;
}
.main-navbar-brand {
  color: #646569;
  font-size: 26px;
  font-family: dfyuanstd-w8, dfyuanstd-w7, dfyuanstd-w5;
  cursor: default;
  text-decoration: none;
}
.main-navbar-brand:hover {
  color: #646569;
}
.main-navbar-button {
  background-color: var(--main-bg-color);
  width: 64px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border-radius: 5px;
  margin-left: 16px;
  cursor: pointer;
  font-size: 16px;
  color: #eefbf0;
}
.main-color {
  color: #646569;
}
.navbar-username {
  width: auto;
  text-align: right;
  font-size: 16px;
  color: var(--main-font-color);
}

.mes-tabs {
  border-bottom: none;
}
.mes-tabs .mes-tab {
  background-color: #c8c9ca;
  font-size: 1rem;
  font-family: dfyuanstd-w5, dfyuanstd-w3;
  color: #666;
  margin-right: 0.2rem;
  border-radius: 0.75rem 0.75rem 0 0;
  border: 1px solid transparent;
  margin-left: 0.15rem;
  width: 146px;
}
.mes-tabs .mes-tab.active {
  border-color: transparent;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
}

.row.content {
  height: calc(100vh - 60px);
}

@media screen and (max-width: 992px) {
  .main-navbar-logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(0%, -50%);
    margin-left: -100px;
  }
  .main-navbar-logo img {
    height: auto;
    width: 200px;
  }
}
@media screen and (max-width: 575px) {
  .main-navbar {
    padding: 4px 16px;
  }
  .row.content {
    height: auto;
  }
  .row.content .main-content {
    height: 100%;
    width: 100% !important;
    overflow: none;
  }
}
@media screen and (max-width: 376px) {
  .main-navbar-logo {
    position: unset;
    transform: none;
    margin: 0px;
  }
  .main-navbar-logo img {
    margin-left: 16px;
  }
}
.main-title {
  font-size: 1.75rem;
  color: #000;
}
</style>
<style lang="scss">
.font-family-dfyuanstd-w5 div {
  font-family: "dfyuanstd-w5";
}
.table-col-hight {
  height: 2.8rem;
}
.table.b-table > thead > tr > [aria-sort="none"],
.table.b-table > tfoot > tr > [aria-sort="none"] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='white' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
}
.table.b-table > thead > tr > [aria-sort="ascending"],
.table.b-table > tfoot > tr > [aria-sort="ascending"] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='white' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='white' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
}
.table.b-table > thead > tr > [aria-sort="descending"],
.table.b-table > tfoot > tr > [aria-sort="descending"] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='white' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='white' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
}
</style>
